import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestDemoInterface } from '../interfaces/request-demo.interface';

export interface RequestDemoDetailDialogData {
  request: RequestDemoInterface;
  statusLabel: string;
}

@Component({
  selector: 'app-request-demo-detail-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './request-demo-detail-dialog.component.html',
  styleUrl: './request-demo-detail-dialog.component.scss'
})
export class RequestDemoDetailDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RequestDemoDetailDialogData,
    private dialogRef: MatDialogRef<RequestDemoDetailDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
